import { computed, h, defineComponent, ref } from 'vue';
import { Modal, modalProps, ModalProps } from '@/ui/components/Modal';
import { Button } from '@/ui/components/Button';
import { pageSubtitle } from '@/ui/components';
import { t } from '@/ui/i18n/i18n';
import { ValidationErrors } from '@/entities/validation';
import { filter } from '@/services/api/resources/group';
import { SelectOptions } from '@/ui/types';
import { useTask } from '@/ui/concerns';
import { filterListToOptions } from '@/ui/helpers';
import { chooseGroupField } from '@/ui/components/role/ChooseGroupField';

export const SelectGroupsModal = defineComponent<ModalProps>({
  name: 'SelectGroupsModal',
  props: modalProps,
  setup(props, context) {
    const groups = ref<number[]>([]);
    const groupsOptions = ref<SelectOptions>([]);

    useTask(
      () => filter(),
      data => {
        groupsOptions.value = filterListToOptions(data);
      },
    ).run();

    const closeModal = () => {
      context.emit('close');
      groups.value = [];
    };

    const validationErrors = computed<ValidationErrors>(() => {
      return [];
    });
    return function render() {
      const modalContent = () => [
        pageSubtitle(t('role.groups-modal.title')),
        h('div', { class: 'role-groups-modal__subtitle' }, t('role.groups-modal.subtitle')),
        h('div', { class: 'role-groups-modal__input-row' }, [
          chooseGroupField(
            {
              props: {
                name: 'groups',
                label: t('role.groups'),
                value: groups.value,
                placeholder: t('role.groups-placeholder'),
                required: false,
                options: groupsOptions.value,
                errors: validationErrors.value,
              },
              on: {
                input: (value: number[]) => { groups.value = value; },
              },
            },
          ),
        ]),
      ];

      return h(Modal, {
        props: {
          ...props,
          customClass: 'role-groups-modal',
          ariaRole: 'dialog',
          trapFocus: true,
          destroyOnHide: false,
          ariaModal: true,
          canCancel: ['x'],
        },
        scopedSlots: {
          actions: () => h('div', [
            h(Button, {
              props: { type: 'is-text', btnClass: 'role-groups-modal__cancel' },
              on: { click: closeModal },
            }, t('modal.cancel')),
            h(Button, {
              on: {
                click: () => {
                  context.emit('groups:selected', groups.value);
                  closeModal();
                },
              },
            }, t('common.save')),
          ]),
        },
        on: {
          close: closeModal,
        },
      }, modalContent());
    };
  },
});
